var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCountriesMerged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "#006FFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12C16 14.6398 15.4629 16.9803 14.6411 18.6239C13.7894 20.3272 12.7979 21 12 21C11.2021 21 10.2106 20.3272 9.35889 18.6239C8.53713 16.9803 8 14.6398 8 12C8 9.36016 8.53713 7.01967 9.35889 5.37615C10.2106 3.67281 11.2021 3 12 3C12.7979 3 13.7894 3.67281 14.6411 5.37615C15.4629 7.01967 16 9.36016 16 12Z",
    stroke: "#006FFF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9H20",
    stroke: "#006FFF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15H20",
    stroke: "#006FFF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCountriesMerged);
export default __webpack_public_path__ + "static/media/icon-countries-merged.7ded320075c2306976a5bbbc65daf77f.svg";
export { ForwardRef as ReactComponent };